import * as React from 'react';
import settings from './settings.json';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import { getMenuIcon } from './helper.js';

export default function TemporaryDrawer({currentSection, setCurrentSection}) {
  const [open, setOpen] = React.useState(false);
  const clickSection = (clickedSection) => {
    console.log(clickedSection);
    setCurrentSection(clickedSection);
  }

  const toggleDrawer = (newOpen: boolean) => () => {
    setOpen(newOpen);
  };

  const DrawerList = (
    <Box sx={{ width: 250 }} role="presentation" onClick={toggleDrawer(false)}>
      <List>
        {settings.sections.map((settingSection, index) => (
          <ListItem key={settingSection.slug} disablePadding>
            <ListItemButton onClick={(e) => clickSection(settingSection.slug)}>
              <ListItemIcon>
                {getMenuIcon(settingSection.slug)}
              </ListItemIcon>
              <ListItemText primary={settingSection.title} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <div>
      <Button onClick={toggleDrawer(true)} sx={{top: 0, position:"fixed", left:0 }}><MenuIcon /> Menu</Button>
      <Drawer slotProps={{paper: { sx: {backgroundColor: "#111111", color: "white" } } }}open={open} onClose={toggleDrawer(false)}>
        {DrawerList}
      </Drawer>
    </div>
  );
}
